module.exports = __webpack_public_path__ + "static/img/child-bg.291ac8e.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/imgs/family/child-bg.png
// module id = ceeu
// module chunks = 1